import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachProtectionInfo = () => {
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  if (!page) {
    return void 0;
  }
  const reference = pageModels?.protectionConfiguration;
  if (!reference) {
    return void 0;
  }
  const protectionDocumentContent = getBrPageContent(page, reference);
  if (!protectionDocumentContent) {
    console.warn(
      `Cannot find main content for Protection Info. Got: ${protectionDocumentContent} for $ref: ${reference.$ref}`
    );
    return void 0;
  }
  const protectionInfoImageContent = protectionDocumentContent.coverImage && page?.getContent(protectionDocumentContent.coverImage);
  return {
    title: protectionDocumentContent.title,
    content: protectionDocumentContent.content,
    image: {
      url: protectionInfoImageContent?.getOriginal().getUrl(),
      alt: protectionInfoImageContent?.getDescription()
    }
  };
};
export {
  useBloomreachProtectionInfo
};
//# sourceMappingURL=use-bloomreach-protection.js.map
